export const DETAIL_KEYS = {
    ITEM_ID: "Item ID",
    TYPE: "Type",
    EVENT: "Event",
    ACCOUNT_ID: "Account ID",
    OLD_VAL: "Old Value",
    NEW_VAL: "New Value"

} as const;